import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { checkTokenExpirationMiddleware } from "../middleware/checkTokenExpirationMiddleware";
import { composeWithDevTools } from "redux-devtools-extension";
// reducers
import { userStateReducer } from "./user/userReducer";
import {
  productListReducer,
  productCreateReducer,
  productDetailsReducer,
  productUpdateReducer,
  productDeleteReducer,
  sizeCreateReducer,
  productApproveReducer,
  productSearchReducer,
  productValidateReducer,
  productStockReducer,
  bulkApplyReducer,
} from "./products/productReducers";
import { categoryListReducer, departmentListReducer } from "./category/categoryReducer";
import { alertReducer } from "./Alert/alert.reducers";
import { merchantReducer } from "./merchant/merchantReducer";
import { orderListReducer } from "./orders/ordersReducer";
import { customerListReducer } from "./customer/customerReducer";
import { emailSendReducer } from "./Email/emailReducer";
import { chatReducer } from "./Chat/chatReducer";
import { collectionReducer } from "./collection/collectionReducer";
import { tagReducer } from "./tag/tagReducer";
import { imageReducer } from "./image/imageReducer";
import { brandReducer } from "./brand/brandReducer";
import { notificationsReducer } from "./notifications/notificationsReducer";
import { ticketReducer } from "./Ticket/ticketReducer";
import { couponReducer } from "./Coupon/couponReducer";
import { enquiryReducer } from "./Enquiry/enquiryReducer";
import { adminReducer } from "./admins/adminsReducer";
import { seoExportReducer } from "./seoexport/seoExportReducer";
import { reviewsReducer } from "./Reviews/reviewsReducer";
import { supportReducer } from "./Support/supportReducer";
import { pageReducer } from "./page/pageReducer";
import { appPageReducer } from "./appPage/appPageReducer";
import { sysSettingsReducer } from "./SysSettings/sysSettingsReducer";
import { blogReducer } from "./blog/blogReducer";
import { blogCategoryReducer } from "./blogCategory/blogCategory.reducer";

const reducer = combineReducers({
  merchantState: merchantReducer,
  alertShow: alertReducer,
  userState: userStateReducer,
  departmentState: departmentListReducer,
  categoryState: categoryListReducer,
  productList: productListReducer,
  productCreate: productCreateReducer,
  productDetails: productDetailsReducer,
  productUpdate: productUpdateReducer,
  productDelete: productDeleteReducer,
  productSearch: productSearchReducer,
  productValidate: productValidateReducer,
  productStock: productStockReducer,
  productBulk: bulkApplyReducer,
  sizesCreate: sizeCreateReducer,
  productApprove: productApproveReducer,
  orderList: orderListReducer,
  customerList: customerListReducer,
  emailsState: emailSendReducer,
  chat: chatReducer,
  collectionState: collectionReducer,
  tagState: tagReducer,
  imageState: imageReducer,
  brandState: brandReducer,
  notificationState: notificationsReducer,
  ticket: ticketReducer,
  enquiries: enquiryReducer,
  couponState: couponReducer,
  adminState: adminReducer,
  seoExportState: seoExportReducer,
  reviewsState: reviewsReducer,
  supportState: supportReducer,
  pageState: pageReducer,
  appPageState: appPageReducer,
  blogState: blogReducer,
  blogCategoryState: blogCategoryReducer,
  sysSettingsState: sysSettingsReducer,
});

const middleware = [thunk];

if (typeof window !== "undefined") {
  var userInfoFromStorage = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  var userdataInfoFromStorage = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : null;

  // var categoriesFromStorage = localStorage.getItem("categories")
  //   ? JSON.parse(localStorage.getItem("categories"))
  //   : null;

  var _rawNotifications = localStorage.getItem("notifications")
    ? JSON.parse(localStorage.getItem("notifications"))
    : null;
  var notificationsFromStorage = Array.isArray(_rawNotifications) ? _rawNotifications : [];
}
var selectedMerchantFromStorage = sessionStorage.getItem("merchantselected")
  ? JSON.parse(sessionStorage.getItem("merchantselected"))
  : null;

// init load user on app load
const initialState = {
  userState: { userInfo: userInfoFromStorage, userData: userdataInfoFromStorage },
  notificationState: { notifications: notificationsFromStorage },
  merchantState: { selectedMerchant: selectedMerchantFromStorage },
};
const store = createStore(
  reducer,
  initialState,
  // composeWithDevTools(applyMiddleware(...middleware, checkTokenExpirationMiddleware))
  composeWithDevTools(applyMiddleware(...middleware))
);
export default store;
